<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" ref="preoutorderTable" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
		
		<detail-index ref="detailIndex" :detail="currentdetail" @modalhide="detailIndexHide" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import detailIndex from '../detail/index.vue'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '预出库订单',
				modal_width:1200,
				modal_height:600,
				currentdetail:[],
				list_formConfig: [{
					field: 'storageId',
					title: '仓库',
					resetValue:55598006,
					itemRender: {
						name: '$select',
						defaultValue:55598006,
						props:{
							emptyoption:false,							
							selectoptions:[
								{value:55598006,label:'温州仓'},
								{value:55840002,label:'佛山仓'},
								{value:66662002,label:'永年仓'}
							]
						}
					}
				}],
				sourcedata:[],
				tasklist:[]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.treeConfig = null
				gridOptions.columns = [{
						width:50,
						align:'center',
						type: 'seq',
						title: '#',
					},{
						field: 'salercpt_no',
						title: '系统编码',
					},
					{
						field: 'storage_name',
						title: '仓库',
					},
					{
						field: 'tp_payment',
						title: '买家付款',
					},
					{
						field: 'tp_pay_time',
						title: '付款时间',
						formatter:({cellValue})=>{
							return cellValue.replace('T',' ').replace('Z',' ')
						}
					},
					{
						field: 'remark',
						title: '备注'
					},
					{
						field: 'task_process',
						title: '未结束任务'
					},
					{
						field: 'task_count',
						title: '拆单次数'
					},
					{
						field: '',
						title: '操作',
						width: 65,
						fixed: "right",
						align: 'center',
						slots: {
							default:({row})=>{
								return	[
										<el-button size="mini" type="text" onClick={()=>{this.detail(row)}}>明细</el-button>,										
									]
							}
						}
					},
				]
				//gridOptions.formConfig = false
			},
			list(page, updateForm) {
				return new Promise((resolve) => {
					// let codes = [
					// 	'XD241121010386',
					// ]
					this.$api.preoutorder.wlnlistTrades(updateForm).then((res)=>{
						this.sourcedata = JSON.parse(JSON.stringify(res))
						this.gettradetask(res).then(()=>{
							resolve({
								list: res
							})
						})
					},()=>{
						resolve({list:[]})
					})
				})
			},
			gettradetask(tabledata){
				let codes = tabledata.map((item)=>{
					return item.salercpt_no
				})
				return new Promise((reslove)=>{
					this.$api.preoutorder.gettradetask({codes:codes}).then((res)=>{
						tabledata.forEach((item)=>{
							item.task_count = 0
							item.task_process = 0
							let task = res.find((_item)=>{
								return _item.salercpt_no == item.salercpt_no
							})
							if(task){
								item.task_count = task.count
								item.task_process = task.process
							}
						})
						reslove()
					})
				})
			},
			detailIndexHide(){
				let tabledata = this.$refs.preoutorderTable.getTableData().fullData
				this.gettradetask(tabledata)
			},
			detail(row){
				this.$api.preoutorder.wlngetOrders({
					tradeUid:row.salercpt_uid,
					storageUid:row.storage_uid,
					shopUid:row.sys_shop,
				}).then((res)=>{
					res.forEach((item)=>{
						item.tp_tid = row.tp_tid
						item.salercpt_no = row.salercpt_no
						item.storage_name = row.storage_name
						item.storage_uid = row.storage_uid
					})
					this.currentdetail = res
					this.$refs.detailIndex.modal_show()
					//console.log(res)
				})
			},
			submit() {
				
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			detailIndex	
		}
	}
</script>